module.exports = __webpack_public_path__ + "img/Women’s Probiotic.34884842.jpg";